import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  onSnapshot,
  serverTimestamp,
  setDoc,
  updateDoc,
} from "firebase/firestore";
import { firestore } from "../../../helpers/firebaseConfig";

const collectionRef = (collectionId) => doc(firestore, "data-collection", collectionId);
const pathsRef = (collectionId) => collection(collectionRef(collectionId), "paths");

export function subscribeToDataCollection(collectionId, onCollection, onPaths, onError) {
  const stopCollection = onSnapshot(collectionRef(collectionId), (snapshot) => {
    onCollection(snapshot.exists() ? { id: snapshot.id, ...snapshot.data() } : null);
  }, onError);

  const stopPaths = onSnapshot(pathsRef(collectionId), (snapshot) => {
    const paths = snapshot.docs
      .map((pathDoc) => {
        const data = pathDoc.data();
        const sourcePoints = data.points || data.coordinates || [];
        return {
          id: pathDoc.id,
          ...data,
          points: sourcePoints
            .map((point, order) => ({
              lat: Number(point.lat ?? point.latitude),
              lng: Number(point.lng ?? point.longitude),
              order: point.order ?? order,
            }))
            .filter((point) => Number.isFinite(point.lat) && Number.isFinite(point.lng)),
        };
      })
      .sort((a, b) => (a.createdAt?.seconds || a.created_at?.seconds || 0) - (b.createdAt?.seconds || b.created_at?.seconds || 0));
    onPaths(paths);
  }, onError);

  return () => {
    stopCollection();
    stopPaths();
  };
}

export async function createPath(collectionId, path) {
  if (path.points.length < 2 || path.points.length > 25) {
    throw new Error("A path must contain between 2 and 25 points.");
  }
  await setDoc(collectionRef(collectionId), {
    updatedAt: serverTimestamp(),
  }, { merge: true });

  return addDoc(pathsRef(collectionId), {
    name: path.name,
    points: path.points.map(({ lat, lng }, order) => ({ lat, lng, order })),
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
}

export function renamePath(collectionId, pathId, name) {
  return updateDoc(doc(pathsRef(collectionId), pathId), {
    name,
    updatedAt: serverTimestamp(),
  });
}

export function removePath(collectionId, pathId) {
  return deleteDoc(doc(pathsRef(collectionId), pathId));
}
